__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amagimedia/stv-v2-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amagimedia/api-client", "1.0.6", () => (Promise.all([__webpack_require__.e(7414), __webpack_require__.e(4733)]).then(() => (() => (__webpack_require__(94733))))));
			register("@amagimedia/commons", "1.26.4", () => (Promise.all([__webpack_require__.e(1303), __webpack_require__.e(7414), __webpack_require__.e(3415), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(9680), __webpack_require__.e(2881), __webpack_require__.e(7221)]).then(() => (() => (__webpack_require__(77221))))));
			register("@amagimedia/stv-content-partner", "2.12.0", () => (Promise.all([__webpack_require__.e(1303), __webpack_require__.e(7414), __webpack_require__.e(3415), __webpack_require__.e(729), __webpack_require__.e(7446), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(9680), __webpack_require__.e(2881), __webpack_require__.e(2983), __webpack_require__.e(4032), __webpack_require__.e(7745)]).then(() => (() => (__webpack_require__(64032))))));
			register("@amagimedia/stv-v2-landing", "1.0.8", () => (Promise.all([__webpack_require__.e(1303), __webpack_require__.e(7414), __webpack_require__.e(3415), __webpack_require__.e(729), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(9680), __webpack_require__.e(2983), __webpack_require__.e(2648)]).then(() => (() => (__webpack_require__(17817))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(7718)]).then(() => (() => (__webpack_require__(30883))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(7660), __webpack_require__.e(7718), __webpack_require__.e(8751), __webpack_require__.e(8634)]).then(() => (() => (__webpack_require__(87660))))));
			register("react-router-dom", "6.28.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(7718), __webpack_require__.e(8751)]).then(() => (() => (__webpack_require__(40245))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2451).then(() => (() => (__webpack_require__(92451))))));
			initExternal(1788);
			initExternal(78090);
			initExternal(3060);
			initExternal(988);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};